import { useTheme } from '@mui/material/styles'
import Slide from '@mui/material/Slide'

export default function SlideTransition(props: any) {
  const theme = useTheme()

  const exitTimeout = props.isReplaced.current
    ? 0
    : theme.transitions.duration.leavingScreen

  return (
    <Slide
      {...props}
      timeout={{
        enter: theme.transitions.duration.enteringScreen,
        exit: exitTimeout,
      }}
    />
  )
}
